import { Target } from '../@types';

const targetsForCategory: Target[] = [
  { value: 'name', type: 'text', isAPI: false },
  { value: 'acrissCode', type: 'text', isAPI: false },
  { value: 'brandId', type: 'selection', isAPI: false },
  { value: 'numOfVehicle', type: 'number', isAPI: false },
];

export default targetsForCategory;
